import Vue from 'vue';
import App from './App';
import router from './router';
import VueFullpage from 'fullpage-vue';
import 'fullpage-vue/src/fullpage.css';
Vue.config.productionTip = false;
Vue.use(VueFullpage);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js